import React, { FC } from 'react';

import { DeliveryInformation } from 'app/pages/order/summary/delivery-information/delivery-information';
import { i18n } from 'app/i18n';
import { DeliveryStaticData } from 'app/static-data/delivery-static-data';
import { I18nUtils } from 'app/utils/i18n-utils';

export const DeliveryInformationTransporter: FC = () => (
    <DeliveryInformation
        deliveryMethod={i18n.page.summary.deliveryInformation.deliveredByTransporter}
        deliveryMethodNote={I18nUtils.message(i18n.page.summary.deliveryInformation.note.deliveredByTransporter, {
            deliveryTime: DeliveryStaticData.DELIVERY_TIME_FOR_TRANSPORTER,
        })}
        linkToMoreInformation={DeliveryStaticData.LINK_TO_DELIVERY_PAGE}
    />
);
